// @ts-nocheck
import React from "react";
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const FeatureCardContainer = styled.div<{ onClick?: () => void; children?: React.ReactNode }>(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: theme.spacing.small,
    paddingRight: theme.spacing.small,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.medium,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.colors[theme.colorMode].border_Subtle_Secondary,
    gap: theme.spacing.xSmall,
}));

export const FeatureIcon = styled(Image)(({ theme }) => ({
    width: theme.spacing.xLarge,
    height: theme.spacing.xLarge,
    marginRight: 6,
    objectFit: "cover",
}));

export const FeatureText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));
